import * as React from 'react';
const PelleSensibileIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}`}</style>
    </defs>
    <path
      d="M94.83 146.4c0-4.3-.11-11.4-1.72-12.03-17.61-6.87-16.03-25.06-30.92-36.09 6.87-12.03 19.75 10.31 24.05 10.31 5.44-15.9-9.88-46.4 0-46.4 4.01 0 7.93 25.32 11.22 25.32s-.7-33.92 7.67-33.92c6.87 0 .36 29.2 4.51 33.35 5.44-.14 3.08-28.19 12.67-28.19 6.01 0-3.95 31.68 0 30.93 3 0 8.3-20.62 13.74-20.62 1.82 0 1.82 1.55 1.72 3.99-.27 6.64-5.59 19.9-7.72 26.69"
      style={{
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
        stroke: primaryColor || '#282828',
      }}
    />
    <path
      d="M109.83 137.77c5.01 3.23 13.73-.4 18.82-3.16l-1.65-2.3s4.5-.91 6.41-1.99c3.66-2.07 5.04-3.43 6.71-5.05 3.52-3.42 7.84-8.65 10-13.34 2.58-5.6 1.79-14.13-16.87-4.07-4.68 2.52-10.15 6.03-11.71 8.35-1.11 1.65-1.96 5.76-1.96 5.76l-1.49-3.28s-11.43 9.35-8.25 19.07Z"
      className="prefix__cls-1"
    />
    <path
      d="M142.54 110.68c-12.93 11.85-29.39 25.2-38.37 31.07"
      className="prefix__cls-1"
    />
  </svg>
);
export default PelleSensibileIcon;
